import { render, staticRenderFns } from "./PublicTenderTabButton.vue?vue&type=template&id=93183e06&scoped=true&"
import script from "./PublicTenderTabButton.vue?vue&type=script&lang=js&"
export * from "./PublicTenderTabButton.vue?vue&type=script&lang=js&"
import style0 from "./PublicTenderTabButton.vue?vue&type=style&index=0&id=93183e06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93183e06",
  null
  
)

export default component.exports